export default {
  setScmsSetting(state, data) {
    state.scmsSetting = data;
  },

  setBuyFactor(state, data) {
    state.buyFactor = data;
  },
  setBuyFactorById(state, data) {
    state.buyFactorById = data;
  },
  setBuyFactorMaxCode(state, data) {
    state.buyFactorMaxCode = data;
  },
  setBuyFactorAttachment(state, data) {
    state.buyFactorAttachment = data;
  },
  setBuyFactorAttachmentById(state, data) {
    state.buyFactorAttachmentById = data;
  },
  setBuyFactorAddMinus(state, data) {
    state.buyFactorAddMinus = data;
  },
  setReadBuyRequestByCode(state, data) {
    state.readBuyRequestByCode = data;
  },
  setReadBuyRequestByCommodity(state, data) {
    state.readBuyRequestByCommodity = data;
  },

  setReturnBuyFactor(state, data) {
    state.returnBuyFactor = data;
  },
  setReturnBuyFactorById(state, data) {
    state.returnBuyFactorById = data;
  },
  setReturnBuyFactorMaxCode(state, data) {
    state.returnBuyFactorMaxCode = data;
  },
  setReturnBuyFactorAttachment(state, data) {
    state.returnBuyFactorAttachment = data;
  },
  setReturnBuyFactorAttachmentById(state, data) {
    state.returnBuyFactorAttachmentById = data;
  },
  setReturnBuyNotes(state, data) {
    state.returnBuyNotes = [...data];
  },

  setLatestBuyPriceOfCommodityReport(state, data) {
    state.latestBuyPriceOfCommodityReport = data;
  },
  setFactorComprehensiveReport(state, data) {
    state.factorComprehensiveReport = data;
  },
  setCommodityComprehensiveReport(state, data) {
    state.commodityComprehensiveReport = data;
  },
  setMonthlyPurchaseSomeReport(state, data) {
    state.monthlyPurchaseSomeReport = data;
  },
  setMonthlyPurchaseMonetaryReport(state, data) {
    state.monthlyPurchaseMonetaryReport = data;
  },

  setBuyNotes(state, data) {
    state.buyNotes = data;
  },

  setBuyReportBySuppliers(state, data) {
    state.buyReportBySuppliers = data;
  },
  setBuyReportBySuppliersFactorList(state, data) {
    state.buyReportBySuppliersFactorList = data;
  },
  setBuyReportBySuppliersCommodityList(state, data) {
    state.buyReportBySuppliersCommodityList = data;
  },
  setBuyReportBySuppliersAddMinusList(state, data) {
    state.buyReportBySuppliersAddMinusList = data;
  },

  setBuyFactorManagementCartable(state, data) {
    state.buyFactorManagementCartable = data;
  },
  setBuyReturnManagementCartable(state, data) {
    state.buyReturnManagementCartable = data;
  },
  setReqBuyManagementCartable(state, data) {
    state.reqBuyManagementCartable = data;
  },

  setReqBuyCartable(state, data) {
    state.reqBuyCartable = data;
  },

  setBuyFactorCartable(state, data) {
    state.buyFactorCartable = data;
  },

  setReturnBuyFactorCartable(state, data) {
    state.returnBuyFactorCartable = data;
  },

  setFactorCalculate(state, data) {
    state.factorCalculate = data;
  },

  setFactorAddMinus(state, data) {
    state.factorAddMinus = data;
  },

  setFactorCalculateAddMinus(state, data) {
    state.factorCalculateAddMinus = data;
  },

  setCartableLog(state, data) {
    state.cartableLog = data;
  },
};
